export const SEARCH_CONSTANTS = {
  MIN_SEARCH_LENGTH: 3,
  DEBOUNCE_TIMEOUT_MS: 300
} as const;
